import { configureStore } from "@reduxjs/toolkit";
import { api } from "./api";
import { authSlice } from "./auth";
import { ErrorHandler } from "./errors";
// #plopStoreImport
import { balanceApi, balanceSlice } from "./balance";
import { benefitsApi, benefitsSlice } from "./benefits";
import { cardApi, cardSlice } from "./card";
import { configApi, configSlice } from "./config";
import { faqApi, faqSlice } from "./faq";
import { historyApi, historySlice } from "./history";
import { missionsApi, missionsSlice } from "./missions";
import { programApi, programSlice } from "./program";
const MIDDLEWARES = [
    // ErrorLogger,
    ErrorHandler,
    // #plopMainStoreMiddlewaresPlaceholder
    configApi.middleware,
    faqApi.middleware,
    historyApi.middleware,
    benefitsApi.middleware,
    missionsApi.middleware,
    balanceApi.middleware,
    cardApi.middleware,
    programApi.middleware,
];
export const store = configureStore({
    reducer: {
        [api.reducerPath]: api.reducer,
        auth: authSlice.reducer,
        // #plopMainStoreSlicePlaceholder
        config: configSlice.reducer,
        faq: faqSlice.reducer,
        history: historySlice.reducer,
        benefits: benefitsSlice.reducer,
        missions: missionsSlice.reducer,
        balance: balanceSlice.reducer,
        card: cardSlice.reducer,
        program: programSlice.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(MIDDLEWARES),
});
//# sourceMappingURL=store.js.map